import * as theme from '../../../theme';
import Heading from "../../../components/Heading";
import VideoPlayer from "../../../components/VideoPlayer";
import ImprintFAQs from './ImprintFAQs';
import ImprintRemedyInstructions from './images/ImprintRemedy-Instructions.png';
import ImprintRemedyKit from './images/ImprintRemedy-Kit.jpg';

function ImprintRemedy({ title }) {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 800, position: 'relative', marginLeft: 'auto', marginRight: 'auto' }}>
      <Heading
        title={title}
        subHeading={true}
        center={true}
      />
      <div style={{ ...theme.SubText, position: 'relative', marginRight: 'auto', marginLeft: 'auto' }}>
        Watch the video below to understand what your client will receive with their Imprint Remedy. This is the same video linked via QR Code on the Imprint Instruction sheet. Review it to understand what information they will receive to help answer any questions they may have.<br /><br />
        As stated in prior training, we will mail the Imprint Remedy kit directly to your client, including detailed instructions on usage and dosing (see example screenshots below).
      </div>
      <VideoPlayer videoId={title} isPublic={false} />
      <div style={{ ...theme.SubText, position: 'relative', marginTop: 40, marginRight: 'auto', marginLeft: 'auto' }}>
        Remind your client to start slowly with 1 drop and work up to the recommended dose. If they have detox effects, lower the dose. It is always fine to take a lower dose for a longer duration as needed.<br /><br />
        Also remind your client that this is a slow gentle process. Changes happen slowly.<br /><br />
        The remedy is giving the body information, and their body chooses what to do with that information. Some clients may see noticeable effects, others might not notice much at all. Just reassure them to keep going.
      </div>
      <ImprintFAQs />
      <div style={{ position: 'relative', marginTop: 40, marginRight: 'auto', marginLeft: 'auto' }}>
        INSTRUCTIONS<br/>
        <img style={{ width: window.innerWidth > 1000 ? 600 : '100%', marginTop: 8, border: `5px solid ${theme.Colors.GoldDark}` }} src={ImprintRemedyInstructions} alt="Imprint Remedy Instructions" /><br/><br/><br/>
        MAILED REMEDY KIT<br/>
        <img style={{ width: window.innerWidth > 1000 ? 600 : '100%', marginTop: 8, border: `5px solid ${theme.Colors.GoldDark}` }} src={ImprintRemedyKit} alt="Imprint Remedy Kit" />
      </div>
    </div>
  );
}

export default ImprintRemedy;